export enum PermissionEnum{
    Read = 1,
    Create = 2,
    Update = 3,
    Delete = 4
}